<template>
    <page-container>
        <template slot="navigation" />
        <template slot="header">
            <v-toolbar fixed dense :color="$root.getTheme().tertiary" elevation="10">
                <v-container fluid class="ma-0 pa-0">
                    <v-row justify="space-between" style="height:48px!important;">
                        <v-col cols="3">
                            <v-toolbar-title v-if="storageData.isInitialized">
                                <span>撮影行事一覧</span>
                            </v-toolbar-title>
                        </v-col>
                        <v-col cols="3">
                            <v-switch v-if="storageData.isInitialized" v-model="storageData.album.is_completed"
                                label="アルバム制作完了" hide-details :ripple="false" class="mt-1 mr-2"
                                @change="changeAlbumStatus" />
                        </v-col>
                        <v-col cols="3" class="ma-0 pa-0">
                            <v-container class="ma-0 py-0 pl-0 pr-6">
                                <v-row justify="end">
                                    <div style="position: relative; display: inline-block;">
                                        <icon-with-text text="行事アップロード" :show-text="showText" icon
                                            icon-name="mdi-folder-upload" style="ma-0" @click="openPhotoUploadDialog" />
                                        <span v-if="shootings.length == 0"
                                            style="position: absolute; top: 25px; right: 6px; width: 6px; height: 6px; background: red; border-radius: 50%;"></span>
                                    </div>
                                    <div style="position: relative; display: inline-block;">
                                        <icon-with-text text="撮影行事作成" :show-text="showText" icon icon-name="mdi-folder-plus"
                                            style="ma-0" @click="createCallback" />
                                        <span v-if="shootings.length == 0"
                                            style="position: absolute; top: 25px; right: 6px; width: 6px; height: 6px; background: red; border-radius: 50%;"></span>
                                    </div>
                                </v-row>
                            </v-container>
                        </v-col>
                    </v-row>
                </v-container>
            </v-toolbar>
        </template>

        <template slot="top" />

        <template slot="middle">
            <v-data-table :headers="headers" :items="shootings" :items-per-page="20" :footer-props="{
                'items-per-page-options': [10, 20, 30, 40, 50, -1]
            }" dense tile @click:row="clickRow">
                <template v-slot:item.edit="{ item }">
                    <v-btn tile x-small color="secondary" @click.stop="editCallback(item.id)">
                        編集
                    </v-btn>
                </template>
                <template v-slot:item.delete="{ item }">
                    <v-btn tile x-small color="accent" @click.stop="deleteShooting(item.id)">
                        削除
                    </v-btn>
                </template>
            </v-data-table>
        </template>

        <template slot="bottom">
            <!-- 人物頻度確認ダイアログ -->
            <v-dialog v-model="storageData.shootingFrequencyDialog" persistent fullscreen hide-overlay
                transition="dialog-bottom-transition">
                <v-card :color="$root.getTheme().background">
                    <shooting-frequency ref="shootingFrequencyVue" :album-id="albumId"
                        :close-callback="closeShootingFrequencyDialog" />
                </v-card>
            </v-dialog>
            <!-- 写真アップロードダイアログ -->
            <photo-upload-dialog ref="photoUploadDialogVue" title="行事アップロード" :album-id="albumId"
                :photos-length="photos.length" :mode="true" :visible="storageData.photoUploadDialog"
                :close-callback="closePhotoUploadDialog" :existing-photo-names="photos.map((p) => {
                    return p.name;
                })
                    " @done-upload="searchPhotos" />
        </template>
    </page-container>
</template>

<script>
import event from '../../utils/event';
import http from '../../services/http';
import urlUtil from '../../utils/url';
import leaveConform from '../../mixins/leave-confirm-mixin';
import monet from 'monet';

export default {
    mixins: [leaveConform],
    props: {
        albumId: {
            default: 0,
            type: [String, Number]
        },
        selectCallback: {
            default: () => { },
            type: Function
        },
        createCallback: {
            default: () => { },
            type: Function,
        },
        editCallback: {
            default: () => { },
            type: Function,
        },
        onlyUnsubmited: {
            default: false,
            type: Boolean,
        },
    },
    components: {
        'shooting-card': require('../Shootings/ShootingCard.vue').default,
        'shooting-frequency': require('../Frequency/ShootingFrequency.vue').default,
        'icon-with-text': require('../Icons/IconWithText.vue').default,
        'photo-upload-dialog': require('../Dialogs/PhotoUploadDialog.vue').default,
    },
    data() {
        return {
            viewID: '',
            drawer: false,
            photos: [],
            storageData: {
                isInitialized: false,
                shootingFrequencyDialog: false,
                photoUploadDialog: false,
            },
            headers: [
                {
                    text: '撮影行事名',
                    value: 'name',
                },
                {
                    text: '状態',
                    value: 'status',
                    width: 200,
                },
                {
                    text: '編集',
                    value: 'edit',
                    align: 'center',
                    sortable: false,
                    width: 64,
                },
                {
                    text: '削除',
                    value: 'delete',
                    align: 'center',
                    sortable: false,
                    width: 64,
                },
            ],
            httpState: http.state,
            shootings: [],
            faces: [],
            showText: true,
        };
    },
    computed: {
        onlyUnsubmitedComputed: {
            get() {
                return this.onlyUnsubmited;
            },
            set(value) {
                this.$emit('update:only-unsubmited', value);
            }
        }
    },
    watch: {
        onlyUnsubmitedComputed() {
            this.fetchShootings();
        },
    },
    created() {
        this.$root.setStep('');

        event
            .on('saveStorage', () => {
                if (this.storageData.isInitialized == true) {
                    this.saveStorageData();
                }
            });
        event.on('updatedShootings', () => {
            this.fetchFaces();
            this.fetchShootings();
        });
    },
    mounted() {
        this.restoreStorageData();
        this.initialize();
    },
    beforeDestroy() {
        event.off('saveStorage');
        event.off('updatedShootings');
    },
    methods: {
        initialize() {
            this.storageData.isInitialized = false;

            Promise.all([this.fetchAlbum(), this.fetchShootings(), this.fetchFaces()])
                .then(() => this.storageData.isInitialized = true)
                .catch(error => {
                    if (error === 'unauthorized') return;
                    console.log('エラー詳細: ' + error);
                    this.showError('初期化処理に失敗しました。', '初期化エラー');
                });
        },
        fetchShootings() {
            return http.get((url => {
                url = urlUtil.addQueryParamIfDefined(url, 'album_id', this.albumId);
                url = urlUtil.addQueryParamIfDefined(url, 'only_unsubmited', this.onlyUnsubmited);
                return url;
            })('shootings'))
                .then(res => this.shootings = res.data.map(item => ({
                    ...item,
                })));
        },
        fetchFaces() {
            return http
                .get('faces?album_id=' + this.albumId)
                .then((res) => {
                    this.faces = res.data;
                    this.$root.setFaceCount(this.faces.length);
                });
        },
        fetchAlbum() {
            return http
                .get('albums/' + this.albumId)
                .then((res) => (this.storageData.album = res.data));
        },
        changeAlbumStatus() {
            this.updateAlbumStatus()
                .then(() => this.fetchAlbum())
                .catch((error) => {
                    this.storageData.album.is_completed =
                        !this.storageData.album.is_completed;

                    if (error === 'unauthorized') return;
                    console.log('エラー詳細: ' + error);
                    this.showError('状態の変更に失敗しました。', '状態変更エラー');
                });
        },
        updateAlbumStatus() {
            return http.put('albums/status/' + this.storageData.album.id, {
                is_completed: this.storageData.album.is_completed,
                updated_at: this.storageData.album.updated_at,
            });
        },
        deleteShooting(shooting_id) {
            const url = 'shootings/delete/' + shooting_id;
            this.showDeleteConfirm('撮影行事を削除します。　\nよろしいですか？', '行事削除')
                .then((confirmResult) => {
                    if (confirmResult) {
                        http.
                            delete(url)
                            .then(() => {
                                this.showInfo('撮影行事の削除が完了しました。', '撮影行事削除');
                                this.fetchShootings();
                            })
                            .catch(error => {
                                if (error === 'unauthorized') return;
                                console.log('エラー詳細: ' + error);
                                this.showError('撮影行事の削除に失敗しました。', '撮影行事削除エラー');
                            });
                    }
                });
        },
        openShootingFrequencyDialog(shootingId) {
            this.storageData.shootingFrequencyDialog = true;

            this.$nextTick(() => this.$refs.shootingFrequencyVue.initialize()
                .then(() => this.$refs.shootingFrequencyVue.setShooting(shootingId))
                .catch(error => {
                    this.closeShootingFrequencyDialog();

                    if (error === 'unauthorized') return;
                    console.log('エラー詳細: ' + error);
                    this.showError('人物頻度確認画面の初期化に失敗しました。', '初期化エラー');
                }));
        },
        closeShootingFrequencyDialog() {
            this.storageData.shootingFrequencyDialog = false;
        },
        changeOnlyUnsubmited(e) {
            this.fetchShootings();
            this.$emit('update:only-unsubmited', e);
        },
        clickRow(row) {
            this.selectCallback(row.id);
        },
        openPhotoUploadDialog() {
            this.storageData.photoUploadDialog = true;
        },
        closePhotoUploadDialog() {
            this.storageData.photoUploadDialog = false;
            this.fetchShootings();
        },
    },
};
</script>